<template>
    <div class="coupon-shell">
        <div class="coupon-tab-list">
            <div class="coupon-tab-box" :class="{'coupon-tab-box-active': item.code==status}"
                 v-for="(item,index) in tab_list" :key="index" @click.stop="cut_tab(item,index)">
                {{item.name}}
            </div>
        </div>
        <div class="coupon-list">
            <div class="coupon-box" v-for="(item,index) in coupon_list" :key="index">
                <img src="@/assets/222222.png" alt="" v-if="status==1">
                <img src="@/assets/yishiyong.png" alt="" v-if="status==2">
                <img src="@/assets/yicuihui.png" alt="" v-if="status==3">
                <div class="coupon-box-content">
                    <div class="coupon-box-header">
                        <div class="coupon-price">
                            {{item.coupon_type==1?'￥'+item.discount_money:(10-item.discount)+'折'}}
                        </div>
                        <div class="coupon-title">{{item.coupon_title}}</div>
                    </div>
                    <div class="coupon-box-bottom">
                        <div class="coupon-tips">有效期限</div>
                        <div class="coupon-time">{{item.start_time}}-{{item.end_time}}</div>
                    </div>
                </div>
            </div>
        </div>
        <NoData v-if="coupon_list.length<1" width="168px" height="235px" :icon="no_icon"></NoData>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'

  export default {
    components: {
      NoData
    },
    data () {
      return {
        tab_list: [
          {
            name: '可使用',
            code: 1
          },
          {
            name: '已使用',
            code: 2
          },
          {
            name: '已过期',
            code: 3
          }
        ],
        coupon_list: [],
        no_icon: require('@/assets/no-coupon.png'),
        status: 1
      }
    },
    mounted () {
      this.get_list()
    },
    methods: {
      cut_tab (item, index) {
        this.status = item.code
        this.get_list()
      },
      //我的优惠券
      get_list () {
        this.API.post('user/coupon_in-get_coupon_list', {
          course_id: 0,
          status: this.status // 	0全部 1.生效 2.已使用 3.过期
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.coupon_list = res.data.coupon_list
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .coupon-shell {
        background-color: #fff;
        margin-bottom: 30px;
        min-height: 50vh;
    }

    .coupon-tab-list {
        display: flex;
        align-items: center;
        height: 76px;
        border-bottom: 1px solid #DCDCDC;
        width: 958px;
        padding: 0 40px;

        .coupon-tab-box {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 72px;
            height: 100%;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 47px;
            cursor: pointer;
        }

        .coupon-tab-box-active {
            color: #2AA9B5;
            position: relative;

            &:after {
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
                content: "";
                width: 110%;
                height: 5px;
                background: #2AA9B5;
                border-radius: 3px;
            }
        }
    }

    .coupon-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0 48px 46px;
        width: 100%;

        .coupon-box {
            position: relative;
            width: 252px;
            height: 285px;
            margin: 46px 4% 0 0;

            .coupon-box-content {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
            }

            .coupon-box-header {
                height: 60%;
                padding-top: 50px;

                .coupon-price {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 43px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFDFD;
                }

                .coupon-title {
                    text-align: center;
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FDFBFB;
                }
            }

            .coupon-box-bottom {
                padding-top: 20px;

                .coupon-tips {
                    text-align: center;
                    font-size: 19px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                }

                .coupon-time {
                    text-align: center;
                    font-size: 19px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    margin-top: 10px;
                }
            }
        }
    }
</style>
